module.exports = __webpack_public_path__ + "img/location.f72a5e3d.svg";